module.exports = __webpack_public_path__ + "img/pdf_customization_upgrade.2c750c9f.png";